var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#666666",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M15.2049 13.952L19 17.7462L17.7462 19L13.952 15.2049C12.5402 16.3366 10.7842 16.9522 8.9748 16.9496C4.57271 16.9496 1 13.3769 1 8.9748C1 4.57271 4.57271 1 8.9748 1C13.3769 1 16.9496 4.57271 16.9496 8.9748C16.9522 10.7842 16.3366 12.5402 15.2049 13.952ZM13.4274 13.2945C14.5517 12.1379 15.1797 10.5878 15.1774 8.9748C15.1774 5.54829 12.4013 2.77218 8.9748 2.77218C5.54829 2.77218 2.77218 5.54829 2.77218 8.9748C2.77218 12.4013 5.54829 15.1774 8.9748 15.1774C10.5878 15.1797 12.1379 14.5517 13.2945 13.4274L13.4274 13.2945Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.645bbba3af7cbd647e049fa74292c011.svg";
export { ForwardRef as ReactComponent };